// FTEDN — Firebase App Check initialization
// Prevents unauthorized API access by verifying app authenticity.
import { getToken, initializeAppCheck, ReCaptchaEnterpriseProvider, type AppCheck } from 'firebase/app-check';
import { firebaseApp } from './firebase';

let appCheckInitialized = false;
let appCheckInstance: AppCheck | null = null;

export function initAppCheck(): AppCheck | null {
  if (appCheckInitialized) return appCheckInstance;

  const isEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';

  if (isEmulator) {
    (globalThis as typeof globalThis & { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  if (!siteKey && !isEmulator) {
    console.warn('[app-check] No VITE_RECAPTCHA_SITE_KEY set — skipping App Check');
    return null;
  }

  try {
    appCheckInstance = initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(siteKey || 'debug-key'),
      isTokenAutoRefreshEnabled: true,
    });
    appCheckInitialized = true;
    return appCheckInstance;
  } catch (err) {
    console.error('[app-check] Failed to initialize:', err);
    return null;
  }
}

export async function getAppCheckToken(): Promise<string | null> {
  if (import.meta.env.VITE_APP_CHECK_ENABLED !== 'true') return null;

  const appCheck = initAppCheck();
  if (!appCheck) return null;

  try {
    const result = await getToken(appCheck);
    return result.token || null;
  } catch (err) {
    console.warn('[app-check] Failed to get token:', err);
    return null;
  }
}
